import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const initialState = {
  page: 0,
  purchasePage: 0,
  balance: "",
  purchaseCard: {
    amount: "",
    otherAmount: "",
    quantity: 1,
    selectedCard: ''
  },
  activateCard: {
    cardNumber: "",
    pinNumber: "",
  },
  cards: [],
  users: [],
};

const acgtCardSlice = createSlice({
  name: "acgtcard",
  initialState,
  reducers: {
    //action creators

    //resetting whole card
    resetAcgtCard: () => initialState,

    //purchase
    setCardPage(state, action) {
      state.page = action.payload;
    },
    setPurchasePrevStep(state, action) {
      state.purchasePage = state.purchasePage - 1
    },
    setPurchaseNextStep(state, action) {
      state.purchasePage = state.purchasePage + 1
    },
    setPurchaseSelectedCard(state,action) {     
      state.purchaseCard.selectedCard = action.payload
    },
    setPurchaseCardAmount(state, action) {
      state.purchaseCard.amount = action.payload;
    },
    clearAmount(state, action) {
      state.purchaseCard.amount = "";
    },
    setPurchaseCardOtherAmount(state, action) {
      state.purchaseCard.otherAmount = action.payload;
    },
    setPurchaseCardQuantity(state, action) {
      state.purchaseCard.quantity = action.payload;
    },
    resetCardPage(state, action) {
      state.purchaseCard = action.payload;
    },
    //activation
    setCardNumber(state, action) {
      state.activateCard.cardNumber = action.payload;
    },
    setPinNumber(state, action) {
      state.activateCard.pinNumber = action.payload;
    },
    resetActivation(state, action) {
      state.activateCard = action.payload;
    },
    setUserAcgtCards(state,action){
      state.cards = action.payload
    }
  },
  //tell our combined reducer to look for additional action types
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return {};
    });
  },
});

export const {
  resetAcgtCard,
  setCardPage,
  setPurchaseCardAmount,
  setPurchaseSelectedCard,
  clearAmount,
  setPurchaseCardOtherAmount,
  setPurchaseCardQuantity,
  resetCardPage,
  setCardNumber,
  setPinNumber,
  resetActivation,
  setUserAcgtCards,
  setPurchasePrevStep,
  setPurchaseNextStep
} = acgtCardSlice.actions;
export const acgtCardReducer = acgtCardSlice.reducer;